<template>
    <div class="page" @click.stop.prevent="jumpUrl">
        <img src="https://cdncos.aigupiao.com/assets/app/toSign.png" />
    </div>
</template>
<script>
export default {
    name: "page_2_fsls",
    data() {
        return {

        }
    },
    props: {
        url: {
            type: String,
            default: ""
        }
    },
    methods: {
        jumpUrl() {
            // followup_url
            this.$srH5CallNativeMethodApp('jump_jufeng_page', {
                url: this.url
            })
        }
    }
}
</script>
<style scoped lang="scss">
.page {
    width: 100%;
    min-height: 100vh;
    background-color: #7B7D7F;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999999;

    img {
        width: 80vw;
        height: auto;
        display: block;
        // margin: 50% auto;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10999999;
    }
}
</style>